<template>
  <v-container fluid grid-list-md  >
    <v-layout row wrap>
    <!-- <br/>
    <v-flex xs12 sm12 md12>
      <v-toolbar card class="primary white--text">
        <router-link v-if="$route.params.customerId !='null'" :to="{ name: 'BuyersInfo', params: { buyerId:$route.params.customerId }}">
          <v-btn outlined="primary">
            <v-icon class="primary--text">keyboard_backspace</v-icon>
          </v-btn>
          </router-link>
          <router-link v-else :to="{ name: 'Dashboard'}">
            <v-btn outlined="primary">
              <v-icon class="primary--text">keyboard_backspace</v-icon>
            </v-btn>
          </router-link>
        </v-toolbar>
      </v-flex> -->

      
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-flex xs12 sm1 md1>
            <router-link style="text-decoration: none;" v-if="$route.params.customerId !='null'" :to="'/buyers/'+$route.params.customerId+'/'+isBuyer" >
              <b class="headline primary white--text">
                {{isBuyer? 'Receipt' : 'Payment'}}
              </b>
            </router-link>
            <router-link style="text-decoration: none;" v-else :to="{ name: 'Dashboard'}">
              <b class="headline primary white--text">
                {{isBuyer? 'Receipt' : 'Payment'}}
              </b>
            </router-link>
          </v-flex>
          <v-spacer/>
          <v-flex xs12 sm1 md1 style="margin-top: 12px; text-decoration: none">
            <v-switch
              v-model="isBuyer"
              class="customer-switch"
              :disabled="$route.params.customerId  !='null'"
              :label="`${
                isBuyer ? 'Customer List' : 'Supplier List'
              }`"
            ></v-switch>
          </v-flex>
          <v-flex xs12 sm3 md3>
            <v-select
                solo
                dense
                class="customer-pay-select-firm"
                :disabled="$route.params.customerId !='null'"
                :items="customerListByBrand"
                label="Search Name"
                item-text="name"
                item-value="value"
                autocomplete
                :autofocus="true"
                v-model="currentUserId"
              ></v-select>
          </v-flex>
          <v-flex xs12 sm1 md1>
            <router-link v-if="currentUser['.key']" style="text-decoration: none;" :to="{
                  name: 'RemainingBalance',
                  params: {
                    customerId: currentUser['.key'],
                  },
                }" >
              <v-btn outlined class="primary--text">
                Balance: <b class="font-weight-bolder">{{balance | amount}} </b>   
              </v-btn>
            </router-link>    
          </v-flex> 
          <v-spacer/>
          <v-flex xs12 sm2 md2 v-if="currentUser['localAddress']">
               Address: {{currentUser['localAddress']}}
          </v-flex> 
          <v-spacer/>
          <v-card-actions class="justify-center">
            <v-btn outlined v-if="$route.params.customerId !='null' || currentUser['.key']" @click="addDiposit()" class="primary--text">
              <v-icon>add</v-icon>
              &nbsp;
                {{isBuyer? 'New Receipt' : 'New Payment'}}
            </v-btn>
          </v-card-actions>          
        </v-toolbar>
        
        <v-data-table
          :headers="paymentHeader"
          :items="paymentListByBrand"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <!-- <td>
              <b>{{ props.item['.key']}}</b>
            </td> -->
            <td >
              <b>{{ props.item['amount'] || 0 | amount }}</b>
            </td> 
            <td >
              <b>{{ props.item['remainingAmount'] || 0 | amount }}</b>
            </td> 
            <td>
              <b>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</b>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="editPayment(props.item)"  :disabled="isSaving">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deletePayment(props.item)"  :disabled="isSaving">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="printPayment(props.item)">
                <v-icon color="pink">print</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog v-model="addDipositDialog" persistent max-width="700px">
      <v-card >
        <v-card-title class="primary white--text">
          <span class="title font-weight-light" >{{isBuyer? 'Receipt' : 'Payment'}} Details</span>
          <v-spacer/>
          <v-switch
            :disabled="currentPayment['.key']"
            v-model="currentPayment.multiFirm"
            :label="`Multi-firm`"
          ></v-switch>
          <v-spacer/>
          <v-btn icon dark @click="addDipositDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="currentPayment.receiptNumber"
                  type="number"
                  readonly
                  label="Receipt Number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md3 class="date-container">
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepicker"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="currentPayment.date"
                    label="Date"
                    readonly
                    class="payment-date"
                  ></v-text-field>
                  <v-date-picker v-model="currentPayment.date" @input="datepicker = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <!-- <v-flex xs12 sm6 md6> -->
              <!-- </v-flex> -->
               <v-flex xs12 sm5 md5>
                  <v-select
                    dense
                    :items="firmsByBrand"
                    label="Select Firm"
                    @change="checkValidity() && setReceiptNumber()"
                    :disabled="currentPayment.multiFirm"
                    v-model="currentPayment.firm"
                  ></v-select>
              </v-flex>
              <v-flex xs12 sm4 md4 >
                <v-select
                    dense
                    :items="[{
                              text: 'Cash',
                              value: 'Cash'
                            }, {
                              text: 'Bank Account',
                              value: 'Bank Account'
                            }]"
                    label="Select Payment Type"
                    @change="checkValidity()"
                    v-model="currentPayment.paymentType"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4 md4>
                    <v-text-field
                      v-model="currentPayment.amount"
                      type="number"
                      label="Amount from Cash"
                      :hint="hintText"
                      @keyup="checkValidity()"
                       v-if="['Cash'].includes(currentPayment.paymentType)"
                    ></v-text-field>
                </v-flex>
                <!-- <v-flex xs12 sm4 md4>
                      <v-select
                        dense
                        :items="banksByFirms"
                        v-if="['Bank Account'].includes(currentPayment.paymentType)"
                        label="Select Bank"
                        @change="checkValidity()"
                        v-model="currentPayment.bank"
                        :disabled="currentPayment.paymentType == 'Cash' || currentPayment.paymentType == ''"
                      ></v-select>
                </v-flex> -->
                <v-flex xs12 sm4 md4>
                    <v-select 
                      dense
                        :items="banksByFirms"
                        v-if="['Bank Account'].includes(currentPayment.paymentType)"
                        label="Select Bank"
                        @change="checkValidity()"
                        v-model="currentPayment.bank"
                        :disabled="currentPayment.paymentType == 'Cash' || currentPayment.paymentType == ''"
                        required
                      >
                      <template slot="selection" slot-scope="data">
                          {{ data.item.account.accountnumber }}
                          {{data.item.account.bankName ? ' | '+ data.item.account.bankName : '' }}
                      </template>
                      <template slot="item" slot-scope="data">
                          <v-list-tile-content>
                              <v-list-tile-title v-html="`${data.item.account.accountnumber}
                                  ${data.item.account.bankName ? ' | '+data.item.account.bankName : '' }
                                  ${data.item.account.accountType ? ' | '+data.item.account.accountType : '' }
                                  | ₹: ${(data.item.account.amount || 0).toLocaleString()}`
                              " />
                          </v-list-tile-content>
                      </template>
                  </v-select>
                  </v-flex>  
                  <v-flex xs12 sm4 md4>
                    <v-text-field
                      v-model="currentPayment.amount"
                      v-if="['Bank Account'].includes(currentPayment.paymentType)"
                      type="number"
                      @keyup="checkValidity()"
                      label="Amount from Bank"
                      :hint="hintText"
                    ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                    <v-select
                      dense
                      @change="checkValidity()"
                      :disabled="currentPayment.paymentType == 'Cash' || currentPayment.paymentType == ''"
                      v-if="['Bank Account'].includes(currentPayment.paymentType)"
                      :items="[{
                          text: 'Cheque',
                          value: 'Cheque'
                        }, {
                          text: 'NEFT',
                          value: 'NEFT'
                        }, {
                          text: 'RTGS',
                          value: 'RTGS'
                        }, {
                          text: 'IMPS',
                          value: 'IMPS'
                        }, {
                          text: 'UPI',
                          value: 'UPI'
                        }]"
                      label="Select Transfer type"
                      v-model="transferType"
                      @input="transferTypeDialog = true"
                    ></v-select>
                    </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
            <v-btn
            color="blue darken-1"
            @click="addDipositDialog = false"
            flat
            :disabled="isSaving"
          >Back</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            @click="getUserInvoices"
            :disabled="!isValidSave || isSaving"
            flat
            v-if="!currentPayment['.key']"
          >Save</v-btn>
          <v-btn
            color="blue darken-1"
            @click="saveUpdatedPayment"
            :disabled="!isValidSave  || isSaving"
            flat
            v-if="!!currentPayment['.key']"
          >Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="transferTypeDialog" max-width="500px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="headline">
            Transfer Information
            <b>{{transferType}}</b>
          </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  type="number"
                  v-model="transferDetails.accountNumber"
                  label="A/C Number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  type="text"
                  v-model="transferDetails.accountHolderName"
                  label="A/C Holder Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field type="text" v-model="transferDetails.bankName" label="Bank Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field type="text" v-model="transferDetails.IFSCcode" label="IFSC Code"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field type="text" v-model="transferDetails.remark" label="Remark"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat  @click.native="transferTypeDialog = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar :timeout="3000" top v-model="snackbar"  color="success">
      {{successText}}
    </v-snackbar>
   <v-dialog v-model="passwordDialog" width="800" persistent>
      <v-card>
        <v-card-title class="headline primary--text" primary-title>
          Enter the password
          <v-spacer></v-spacer>
          <v-btn icon dark class="primary" @click="passwordDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
         </v-card-title>

        <v-card-text>
           <v-text-field
            v-model="password"
            type="password"
            label="Password"
            autocomplete="false"
          ></v-text-field>
         </v-card-text>

         <v-divider></v-divider>

        <v-card-actions>
           <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteFromDialog()">Delete</v-btn>
        </v-card-actions>
      </v-card>
     </v-dialog>

  </v-container>
</template>
<style>
.customer-payment .theme--light.v-label {
    color: white;
}

.customer-payment .v-input--switch__track {
    color: rgba(255, 255, 255, 0.38);
}
</style>
<script>
import { createNamespacedHelpers } from "vuex";
import { paymentReceiptPDF } from '../../../utils/PaymentReceipt';
import {digitsToWords} from '../../../utils/digitsToWords.js'

const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
export default {
  data() {
    return {
      addDipositDialog: false,
      defaultFirm : null,
      currentPayment: {},
      isSaving : false,
      snackbar:false,
      successText : '',
      hintText : null,
      selectedInvoices:[],
      currentUser: {},
      balance : 0,
      datepicker: null,
      transferType : null,
      transferTypeDialog : false,
      paymentHeader: [
        // { text: "ID", value: "payment - ID" },
        { text: "Amount", value: "quantity" },
        { text: "Remaining Amount", value: "quantity" },
        { text: "Date", value: "date", sortable: true },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "delete" },
        { text: "Print", value: "print" }
      ],
      isBuyer:true,
      transferDetails: {
        accountNumber:"",
        accountHolderName: "",
        bankName: "",
        IFSCcode: "",
        remark: ""
      },
      password:null,
      passwordDialog : false,
      currentPasswordReference : null,
      currentPasswordMethod : null,
      isValidSave : false,
      currentUserId : null,
    };
  },
  mounted() {
    this.getCurrentUser();
    this.getBalance();
  },
  created() {
    this.$bindAsArray(
      "customerPayments",
      this.$root.$firebaseRefs.customerPayments.orderByChild('brand').equalTo(this.selectedBrand)
    ),
    this.$bindAsArray(
      'buyers',
      this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)
    ),
    this.$bindAsArray(
      'sellers',
      this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'invoice',
      this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject("productById", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray('invoiceHistories',this.$root.$firebaseRefs.invoiceHistory.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("customerDeposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray(
      "firmSettings",
      this.$root.$firebaseRefs.firmSettings
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  watch : {
    "currentUserId" : {
      handler(newVal){
        if(newVal) {
          if(this.isBuyer) {
            this.currentUser =  this.buyers.find(item => item['.key'] == newVal)
          } else {
             this.currentUser =  this.sellers.find(item => item['.key'] == newVal)
          }
          this.getBalance()
        }
      }
    },
    "currentPayment.amount" : {
      handler(){
        this.hintText = this.currentPayment.amount ? _.startCase(digitsToWords(Number.parseFloat(this.currentPayment.amount))) : null
      },
      deep : true
    },
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand",'finYear']),
    
    paymentListByBrand() {
      return this.customerPayments.filter(
        item => (item["brand"] === this.selectedBrand &&
            (item.buyerId == this.currentUser['.key']) &&
            (item.date >= this.finYear.start) && (item.date <= this.finYear.end))
      );
    },
   
    firmsByBrand() {
      return this.firms
        .filter(item => item["brand"] === this.selectedBrand)
        .map(item => {
           if (item.defaultFirm) {
              this.defaultFirm = item['.key'];
          }
          return {
            text: item["name"],
            value: item[".key"]
          };
        });
    },
     banksByFirms() {
      return this.banks
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand &&
            item["firm"] === this.currentPayment['firm']
          );
        })
        .map(item => {
          return {
            account: item,
            text: item["bankName"],
            value: item[".key"]
          };
        });
    },
    customerListByBrand() {
      if(this.isBuyer) {
        return this.buyers.filter((item) => {
          return item["brand"] === this.selectedBrand;
        }).map(item => {
          return {
            name : item.name + " | " + (item['localAddress'] || ""),
            value : item['.key']
          }
        });
      } else {
        return this.sellers.filter((item) => {
          return item["brand"] === this.selectedBrand;
        }).map(item => {
          return {
            name : item.name,
            value : item['.key']
          }
        });
      }
    
    },
  },
  methods: {
    //  getBalance(){
    //   let remainingAmount = 0;
    //   this.invoice.filter(
    //     item =>
    //       (item["brand"] === this.selectedBrand &&
    //       (item.deleted != true) &&
    //       (item.buyerId == this.currentUser['.key']) &&
    //       (item["status"] === "due" || item["status"] === "partial"))
    //   ).map((item)=>{
    //       remainingAmount += item.totalAmount ? Number.parseFloat(item.totalAmount) : 0;
    //       remainingAmount -= item.paidAmount ? Number.parseFloat(item.paidAmount) : 0;
    //   });
    //   this.balance = ((remainingAmount ? Number.parseFloat(remainingAmount) : 0) + this.getDepositeAmount())
    // },
      getBalance(){
        let filteredInvoice = Object.assign([],this.invoiceHistories.filter(item =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.currentUser['.key']
          && (!item["deleted"])
          && (item['returnStatus'] ? (item['returnStatus'] == 'remaining' && item['status'] =='paid') :true)
          && (item['isLatest'] != undefined ? item['isLatest'] == true : true)
        ));
        let payments  = Object.assign([],this.customerPayments.filter(item =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.currentUser['.key'] &&
          (Number.parseFloat(item["remainingAmount"]) > 0)
        ));
        let customerDeposit  = Object.assign([],this.customerDeposit.filter(item =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.currentUser['.key'] &&
          (item["type"] === "Advance" || item["type"] === "Opening Balance" || item["type"] === "LoanTaken" || item["type"] === "LoanGiven" || item["type"] === "Security")
        ));
  
        filteredInvoice.map((item, index) => { 
        //if(item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
        if(item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
        let newItem = JSON.parse(JSON.stringify(item));
          newItem.date = newItem.date-1;
          newItem.transactionType = "Debit";
          newItem.paidAmount = 0;
          newItem.status = 'due';
          newItem.remainingAmount = newItem.totalAmount;
          delete newItem['newlyCreated'];
          filteredInvoice.push(newItem);
        }
        if(item.closedDate) {
          filteredInvoice[index].date = item.closedDate
        }
      });

      customerDeposit.map((deposit,index)=>{
        filteredInvoice.push(deposit)
        if((deposit["type"] === "LoanTaken" || deposit["type"] === "LoanGiven") && deposit.status =="paid" && !deposit.loanTransaction) {
          customerDeposit[index].status = 'due';
        }
      })

      payments.map((pay)=>{
        pay['type'] = 'CustomerPayment'
        filteredInvoice.push(pay)
      })
      filteredInvoice.sort(function(a,b){
        return -(new Date(b.date) - new Date(a.date));
      });


      filteredInvoice.map((item, index) => {

        filteredInvoice[index]["debit"] = this.getDebit(filteredInvoice[index]);
        filteredInvoice[index]["credit"] = this.getCredit(
          filteredInvoice[index]
        );
        if(item.isBuyer) {
          let temp = filteredInvoice[index]["credit"];
          filteredInvoice[index]["credit"] = filteredInvoice[index]["debit"];
          filteredInvoice[index]["debit"] = temp;
        }
        filteredInvoice[index]["RunningBal"] =
          Number.parseFloat(filteredInvoice[index]["debit"] || 0) -
           Number.parseFloat(filteredInvoice[index]["credit"] || 0) +
          (index == 0 ? 0 :  Number.parseFloat(filteredInvoice[index - 1]["RunningBal"]));
      });
      // this.balance = filteredInvoice[filteredInvoice.length-1]["RunningBal"]
      this.balance = filteredInvoice && filteredInvoice.length ? filteredInvoice[filteredInvoice.length-1]["RunningBal"] : 0;
    }, 
    getDebit(item) {
      if(item.type =='CustomerPayment') {
        if (!item.isBuyer) {
          return 0;
        } else {
          return item['remainingAmount'];
        }
      }
      else if(['LoanTaken','LoanGiven','Opening Balance','Advance','Security'].includes(item.type)) {
        switch (item.type) {
          case 'LoanTaken' : {
            if(item.loanTransaction) {
              return 0;
            } else {
              return Number.parseFloat(item.amount);
            }
            break;
          }
          case 'LoanGiven' : {
            if(item.loanTransaction) {
              if(item.loanPaymentType == 'interest') {
                return Number.parseFloat(item.paidInterest);
              } else {
                return Number.parseFloat(item.paidAmount);
              }
            }
            else {
              return 0 ;
            }
            break;
          }
          case 'Opening Balance' : {
            // if(item.status == 'due') {
            //   return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.amount);
            // } else if((item.status == 'paid' || item.status == 'partial' )) {
            //   return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
            // } 
            // else {
            //   return 0 ;
            // }
            // return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
            return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
            break;
          }
          case 'Advance' : {
            return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
            break;
          }
          case 'Security' : {
            return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
            break;
          }
        }
      } else {
         switch(item.status) {
              case 'due' : {
                  return 0;
                  break;
              }
              case 'paid' : {
                  // return (Number.parseFloat(item['totalAmount']));
                  return (Number.parseFloat(item['amountFromBank']) + Number.parseFloat(item['amountFromCash']));
                  break;
              }
              case 'partial' : {
                  return (Number.parseFloat(item['amountFromBank']) + Number.parseFloat(item['amountFromCash']));
                  break;
              }
          }
      }
    },
    getCredit(item) {
      if(item.type =='CustomerPayment') {
        if (item.isBuyer) {
          return 0;
        } else {
          return item['remainingAmount'];
        }
      }
        else if(['LoanTaken','LoanGiven','Opening Balance','Advance','Security'].includes(item.type)) {
        switch (item.type) {
          case 'LoanTaken' : {
            if(item.loanTransaction) {
              if(item.loanPaymentType == 'interest') {
                return Number.parseFloat(item.paidInterest);
              } else {
                return Number.parseFloat(item.paidAmount);
              }
            } else {
              return 0;
            }
            break;
          }
          case 'LoanGiven' : {
            if(item.loanTransaction) {
              return 0;
            }
            else {
              return Number.parseFloat(item.amount);
            }
            break;
          }
          case 'Opening Balance' : {
              return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
            break;
          }
          case 'Advance' : {
            return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
            break;
          }
          case 'Security' : {
            return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
            break;
          }
        }
      } else {
          switch(item.status) {
                case 'due' : {
                    return item.totalAmount;
                    break;
                }
                case 'paid' : {
                    return 0;
                    break;
                }
                case 'partial' : {
                    return 0;
                    break;
                }
            }
      }
    },
    getUserInvoices(){
      this.selectedInvoices = [];
      let dueInvoices = Object.assign([],this.invoice.filter(
        item =>
          (item["brand"] === this.selectedBrand &&
          (item.deleted != true) &&
          ((this.currentPayment.firm && !this.currentPayment.multiFirm) ? (item.firm == this.currentPayment.firm) : true)&&
          (item.buyerId == this.currentUser['.key']) &&
          (item["status"] === "due" || item["status"] === "partial"))
      ));
      let amountToBePaid = Number.parseFloat(this.currentPayment.amount);
      let openingBalance = Object.assign([],this.customerDeposit.filter(
        item =>
          item["brand"] === this.selectedBrand &&
          (item.buyerId == this.currentUser['.key']) &&
          item["type"] === "Opening Balance" &&
           !!item["isUserCreated"] && 
          (parseInt(item["remainingAmount"]) > 0) && 
          ((this.currentPayment.firm && !this.currentPayment.multiFirm) ? (item.firm == this.currentPayment.firm) : true)
      ));
      openingBalance.map((invoice)=>{
        if(invoice['.key']) {
          if(amountToBePaid >= Number.parseFloat(invoice.remainingAmount)) {
            amountToBePaid = amountToBePaid- Number.parseFloat(invoice.remainingAmount)
            this.selectedInvoices.push({
              invoiceId:invoice['.key'],
              settledAmount:Number.parseFloat(invoice.remainingAmount),
              status: 'paid',
              invoiceType : "Opening Balance",
              invoice : invoice
            })
          } else if(amountToBePaid>0) {
            this.selectedInvoices.push({
              invoiceId:invoice['.key'],
              settledAmount:Number.parseFloat(amountToBePaid),
              status: 'partial',
              invoiceType : "Opening Balance",
              invoice : invoice
            })
            amountToBePaid = 0;
          }
        }
      })
      dueInvoices.map((invoice)=>{
        if(invoice['.key']) {
          if(amountToBePaid >= Number.parseFloat(invoice.remainingAmount)) {
            amountToBePaid = amountToBePaid- Number.parseFloat(invoice.remainingAmount)
            this.selectedInvoices.push({
              invoiceId:invoice['.key'],
              settledAmount:Number.parseFloat(invoice.remainingAmount),
              status: 'paid',
              invoice : invoice
            })
          } else if(amountToBePaid>0) {
            this.selectedInvoices.push({
              invoiceId:invoice['.key'],
              settledAmount:Number.parseFloat(amountToBePaid),
              status: 'partial',
              invoice : invoice
            })
            amountToBePaid = 0;
          }
        }
      })
      this.currentPayment.remainingAmount = amountToBePaid;
      this.paySelectedInvoice();
    },
    paySelectedInvoice(){
      this.isSaving = true;
      let closedDate = new Date(this.currentPayment.date);
      let todayDate = new Date()
      let selectedDate = new Date(closedDate.getFullYear(),closedDate.getMonth(),closedDate.getDate(),todayDate.getHours(),todayDate.getMinutes(),todayDate.getSeconds())
      this.selectedInvoices.map((item,index)=>{
        if(item.invoiceType == 'Opening Balance') {
          let invoiceToUpdate = Object.assign({},item.invoice);
          this.$root.$firebaseRefs.customerDeposit.child(invoiceToUpdate['.key']).update({
            remainingAmount: (Number.parseFloat(invoiceToUpdate['remainingAmount']) - Number.parseFloat(item.settledAmount))
          });
          invoiceToUpdate['settledAmount'] =  Number.parseFloat(item.settledAmount)
          invoiceToUpdate['amount'] = 0;
          invoiceToUpdate['status'] = item.status;
          invoiceToUpdate['paymentType'] = this.currentPayment.paymentType;
          invoiceToUpdate['remainingAmount'] = 0;
          invoiceToUpdate['isUserCreated'] = false;
          invoiceToUpdate['date'] =  new Date(selectedDate).getTime();
          
         if(this.currentPayment.paymentType == 'Cash') {
         } else {
           invoiceToUpdate['bank'] = this.currentPayment.bank;
           invoiceToUpdate['transferType'] = this.transferType;
           invoiceToUpdate['transferDetails'] = this.transferDetails;
         }
          delete invoiceToUpdate['.key'];
          let newdeposite = this.$root.$firebaseRefs.customerDeposit.push(invoiceToUpdate);
          switch(invoiceToUpdate.paymentType) {
            case 'Cash' : {
              if(invoiceToUpdate.settledAmount) {
                let firm =  Object.assign({},this.firms.filter(item => item['.key'] == invoiceToUpdate.firm)[0])
                if(firm && (invoiceToUpdate.status == 'paid' || invoiceToUpdate.status == 'partial')) {
                  firm.amount = invoiceToUpdate.isBuyer ? (Number.parseFloat(firm.amount) + Number.parseFloat(invoiceToUpdate.settledAmount)) : (Number.parseFloat(firm.amount) - Number.parseFloat(invoiceToUpdate.settledAmount));   
                  delete firm['.key']
                  this.$root.$firebaseRefs.firm.child(invoiceToUpdate.firm).set(firm);
                }
              }
              break;
            }
            case 'Bank Account' : {
              if(invoiceToUpdate.settledAmount) {
                let bank =   Object.assign({},this.banks.filter(item => item['.key'] == invoiceToUpdate.bank)[0])
                if(bank && (invoiceToUpdate.status == 'paid' || invoiceToUpdate.status == 'partial')) {
                  bank.amount = invoiceToUpdate.isBuyer ? (Number.parseFloat(bank.amount) + Number.parseFloat(invoiceToUpdate.settledAmount)) : (Number.parseFloat(bank.amount) - Number.parseFloat(invoiceToUpdate.settledAmount)) ;  
                  delete bank['.key']
                  this.$root.$firebaseRefs.account.child(invoiceToUpdate.bank).set(bank);
                }
              }
              break;
            }
          }
          this.selectedInvoices[index]['newInvoice'] = newdeposite['key']
        } else {
          let invoiceToUpdate = Object.assign({},item.invoice);
          invoiceToUpdate['closedDate'] = new Date(selectedDate).getTime();
          invoiceToUpdate['status'] = item.status;
          if(this.currentPayment.paymentType == 'Cash') {
            invoiceToUpdate['amountFromCash'] = (invoiceToUpdate['amountFromCash'] ? (Number.parseFloat(invoiceToUpdate['amountFromCash']) + Number.parseFloat(item.settledAmount)) :  Number.parseFloat(item.settledAmount));
            // invoiceToUpdate['remainingAmount'] = Number.parseFloat(invoiceToUpdate['totalAmount']) -Number.parseFloat(invoiceToUpdate['amountFromCash']);
            invoiceToUpdate['remainingAmount'] = Number.parseFloat(invoiceToUpdate['totalAmount']) -(Number.parseFloat(invoiceToUpdate['amountFromCash']) + Number.parseFloat( invoiceToUpdate['amountFromBank']));
          } else {
            invoiceToUpdate['amountFromBank'] = (invoiceToUpdate['amountFromBank'] ? (Number.parseFloat(invoiceToUpdate['amountFromBank']) + Number.parseFloat(item.settledAmount)) :  Number.parseFloat(item.settledAmount));
            // invoiceToUpdate['remainingAmount'] = Number.parseFloat(invoiceToUpdate['totalAmount']) -Number.parseFloat(invoiceToUpdate['amountFromBank']);
            invoiceToUpdate['remainingAmount'] = Number.parseFloat(invoiceToUpdate['totalAmount']) -(Number.parseFloat(invoiceToUpdate['amountFromCash']) + Number.parseFloat( invoiceToUpdate['amountFromBank']));
            invoiceToUpdate['bank'] = this.currentPayment.bank;
            invoiceToUpdate['transferType'] = this.transferType;
            invoiceToUpdate['transferDetails'] = this.transferDetails;
          }
          invoiceToUpdate['transactionType'] = "Credit";
          invoiceToUpdate['paymentType'] = this.currentPayment.paymentType;
          // invoiceToUpdate['date'] = new Date(this.currentPayment.date).getTime();
          invoiceToUpdate['paidAmount'] = Number.parseFloat(invoiceToUpdate.amountFromCash ? Number.parseFloat(invoiceToUpdate.amountFromCash) :0) + (invoiceToUpdate.amountFromBank  ? Number.parseFloat(invoiceToUpdate.amountFromBank) :0)
        
          this.selectedInvoices[index]['oldInvoiceHistoryId'] = this.updateInvoice(invoiceToUpdate,item.settledAmount);
        }
        delete this.selectedInvoices[index]['invoice'];
      })
      this.currentPayment['settledInvoiceDetails'] = this.selectedInvoices;
      if(!!this.currentPayment['.key']) {
        this.updatePayment();
      } else {
        this.savePayment();
      }
    },
    updateInvoice (invoiceData,settledAmount) {
      console.log('Update Invoice Called')
      let latestInvKey = null;
      // this.dialog = false
      console.info(invoiceData);
      const updated_at = new Date().getTime()
      try {
          invoiceData['items'].forEach((item, index) => {
          item['date'] = invoiceData['date']
          if(item.id) {
            item['updated_at'] = updated_at;
            this.$root.$firebaseRefs.item.child(item['id']).update(item, () => {
              console.info('item udpated...')
            })
          } else {
            const response = this.$root.$firebaseRefs.item.push(item, () => {
              console.info('item pushed...')
            })
            invoiceData['items'][index]['id'] = response['key']
          }
        })
        invoiceData['updated_at'] = updated_at;
        let key = invoiceData['.key'];
        delete invoiceData['.key']
        
        this.$root.$firebaseRefs.invoice.child(key).update(invoiceData, () => {
          console.info('invoice updated...')
          if(this.dialog) 
          this.dialog = false;
          this.managePayments(invoiceData);
        })
        invoiceData['parentInvoiceKey'] = key;
        delete invoiceData['newlyCreated'];
          let letestInv =  Object.assign({}, this.invoiceHistories.filter(item =>
          item['brand'] == this.selectedBrand &&
          item['isLatest'] == true && 
          item['parentInvoiceKey'] == key
          )[0]);
          latestInvKey = letestInv['.key'];
          delete letestInv['.key']
          delete letestInv['isLatest'];
          this.$root.$firebaseRefs.invoiceHistory.child(latestInvKey).set(letestInv, () => {
          
          })
          invoiceData['isLatest'] = true;
          if(invoiceData.paymentType == 'Cash') {
            invoiceData['amountFromCash'] = Number.parseFloat(settledAmount)
            invoiceData['amountFromBank'] = 0
          } else {
            invoiceData['amountFromBank'] = Number.parseFloat(settledAmount)
            invoiceData['amountFromCash'] = 0
          }
          this.$root.$firebaseRefs.invoiceHistory.push(invoiceData);
       
      } catch(e) {
        console.info('Error at update Invoice', e)
      }
      return latestInvKey;
    },
    saveUpdatedPayment(){
      this.undoInvoicePayment(this.currentPayment,true);
      this.getUserInvoices();
    },
    undoInvoicePayment(payment,manageBeforePayments){
      payment.settledInvoiceDetails && payment.settledInvoiceDetails.map((inv)=>{
        if(inv.invoiceType == 'Opening Balance') { 
          let oldInvoiceData = Object.assign({},this.customerDeposit.filter(item => item['.key'] == inv['invoiceId'])[0]);
          this.$root.$firebaseRefs.customerDeposit.child(inv['newInvoice']).remove();
          this.$root.$firebaseRefs.customerDeposit.child(inv['invoiceId']).update({
            remainingAmount: (Number.parseFloat(oldInvoiceData['remainingAmount']) + Number.parseFloat(inv.settledAmount))
          });
        } else {
          console.log(this.invoice)
          let invoiceData = Object.assign({},this.invoice.filter(item => item['.key'] == inv['invoiceId'])[0]);
          if(manageBeforePayments) {
            this.manageBeforePayments(invoiceData);
          }
          let oldInvoiceData =  Object.assign({}, this.invoiceHistories.filter(item => item['.key'] == inv['oldInvoiceHistoryId'])[0])
          let letestInv = Object.assign({},this.invoiceHistories.filter(item =>
            item['brand'] == this.selectedBrand &&
            item['isLatest'] == true && 
            item['parentInvoiceKey'] == inv['invoiceId']
            )[0])
          this.$root.$firebaseRefs.invoiceHistory.child(letestInv['.key']).remove();
          if(oldInvoiceData['closedDate']) {
            invoiceData['closedDate'] = oldInvoiceData['closedDate']
          } else {
            delete invoiceData['closedDate']
          }
          if(oldInvoiceData['paymentType']) {
            invoiceData['paymentType'] = oldInvoiceData['paymentType']
          } else {
            delete invoiceData['paymentType']
          }
          if(!!Number.parseFloat(oldInvoiceData['amountFromCash'])) {
            invoiceData['amountFromCash'] = oldInvoiceData['amountFromCash']
          } else {
            invoiceData['amountFromCash'] = 0;
          }
          if(!!Number.parseFloat(oldInvoiceData['amountFromBank'])) {
            invoiceData['amountFromBank'] = oldInvoiceData['amountFromBank']
          } else {
            invoiceData['amountFromBank'] = 0;
          }
          if(oldInvoiceData['bank']) {
              invoiceData['bank'] = oldInvoiceData['bank']
            } else {
              delete invoiceData['bank']
          }
          if(oldInvoiceData['transferType']) {
              invoiceData['transferType'] = oldInvoiceData['transferType']
            } else {
              delete invoiceData['transferType']
          }

          if(oldInvoiceData['transferDetails']) {
              invoiceData['transferDetails'] = oldInvoiceData['transferDetails']
            } else {
              delete invoiceData['transferDetails']
          }
          invoiceData['status'] = oldInvoiceData.status;
          invoiceData['remainingAmount'] = oldInvoiceData.remainingAmount;
          invoiceData['date'] = oldInvoiceData.date;
          invoiceData['paidAmount'] = oldInvoiceData.paidAmount;
          delete invoiceData['.key']
          this.$root.$firebaseRefs.invoice.child(inv['invoiceId']).update(invoiceData, () => {
            // this.manageBeforePayments(invoiceData);
          })
          // oldInvoiceData['isLatest'] = true;
          // delete oldInvoiceData['.key']
          this.$root.$firebaseRefs.invoiceHistory.child(inv['oldInvoiceHistoryId']).update({isLatest : true}, () => {
          })
        }
      })
    },
    manageBeforePayments(invoiceData){
       switch(invoiceData.paymentType) {
          case 'Cash' : {
            if(invoiceData.amountFromCash) {
              let firm = Object.assign({},this.firms.filter(item => item['.key'] == invoiceData.firm)[0])
              if(firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                firm.amount = invoiceData.isBuyer ? (Number.parseFloat(firm.amount) - Number.parseFloat(invoiceData.amountFromCash)) : (Number.parseFloat(firm.amount) + Number.parseFloat(invoiceData.amountFromCash));   
                delete firm['.key']
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }
            }
            break;
          }
          case 'Bank Account' : {
            if(invoiceData.amountFromBank) {
              let bank =  Object.assign({},this.banks.filter(item => item['.key'] == invoiceData.bank)[0])
              if(bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                bank.amount = invoiceData.isBuyer ? (Number.parseFloat(bank.amount) - Number.parseFloat(invoiceData.amountFromBank)) : (Number.parseFloat(bank.amount) + Number.parseFloat(invoiceData.amountFromBank)) ;  
                delete bank['.key']
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
            }
            break;
          }
          case 'CashAndBank Account' : {
            if(invoiceData.amountFromCash && invoiceData.amountFromBank) {
              let bank =  Object.assign({},this.banks.filter(item => item['.key'] == invoiceData.bank)[0])
              if(bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                bank.amount = invoiceData.isBuyer ? Number.parseFloat(bank.amount) - Number.parseFloat(invoiceData.amountFromBank) : Number.parseFloat(bank.amount) + Number.parseFloat(invoiceData.amountFromBank);  
                delete bank['.key']
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
              let firm =  Object.assign({},this.firms.filter(item => item['.key'] == invoiceData.firm)[0])
              if(firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                firm.amount = invoiceData.isBuyer ? Number.parseFloat(firm.amount) - Number.parseFloat(invoiceData.amountFromCash) : Number.parseFloat(firm.amount) + Number.parseFloat(invoiceData.amountFromCash);
                delete firm['.key']
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }         
            }
            break;
          }
        }
    },
    managePayments(invoiceData){
       switch(invoiceData.paymentType) {
          case 'Cash' : {
            if(invoiceData.amountFromCash) {
              let firm =  Object.assign({},this.firms.filter(item => item['.key'] == invoiceData.firm)[0])
              if(firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                firm.amount = invoiceData.isBuyer ? (Number.parseFloat(firm.amount) + Number.parseFloat(invoiceData.amountFromCash)) : (Number.parseFloat(firm.amount) - Number.parseFloat(invoiceData.amountFromCash));   
                delete firm['.key']
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }
            }
            break;
          }
          case 'Bank Account' : {
            if(invoiceData.amountFromBank) {
              let bank =   Object.assign({},this.banks.filter(item => item['.key'] == invoiceData.bank)[0])
              if(bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                bank.amount = invoiceData.isBuyer ? (Number.parseFloat(bank.amount) + Number.parseFloat(invoiceData.amountFromBank)) : (Number.parseFloat(bank.amount) - Number.parseFloat(invoiceData.amountFromBank)) ;  
                delete bank['.key']
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
            }
            break;
          }
          case 'CashAndBank Account' : {
            if(invoiceData.amountFromCash && invoiceData.amountFromBank) {
              let bank =  Object.assign({},this.banks.filter(item => item['.key'] == invoiceData.bank)[0])
              if(bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                bank.amount = invoiceData.isBuyer ? Number.parseFloat(bank.amount) + Number.parseFloat(invoiceData.amountFromBank) : Number.parseFloat(bank.amount) - Number.parseFloat(invoiceData.amountFromBank);  
                delete bank['.key']
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
              let firm =  Object.assign({},this.firms.filter(item => item['.key'] == invoiceData.firm)[0])
              if(firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                firm.amount = invoiceData.isBuyer ? Number.parseFloat(firm.amount) + Number.parseFloat(invoiceData.amountFromCash) : Number.parseFloat(firm.amount) - Number.parseFloat(invoiceData.amountFromCash);
                delete firm['.key']
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }         
            }
            break;
          }
        }
    },
     manageDeletes(invoiceData){
       switch(invoiceData.paymentType) {
          case 'Cash' : {
            if(invoiceData.amount) {
              let firm =  Object.assign({},this.firms.filter(item => item['.key'] == invoiceData.firm)[0])
              if(firm) {
                firm.amount = invoiceData.isBuyer ? (Number.parseFloat(firm.amount) - Number.parseFloat(invoiceData.amount)) : (Number.parseFloat(firm.amount) + Number.parseFloat(invoiceData.amount));   
                delete firm['.key']
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }
            }
            break;
          }
          case 'Bank Account' : {
            if(invoiceData.amount) {
              let bank =  Object.assign({},this.banks.filter(item => item['.key'] == invoiceData.bank)[0])
              if(bank) {
                bank.amount = invoiceData.isBuyer ? (Number.parseFloat(bank.amount) - Number.parseFloat(invoiceData.amount)) : (Number.parseFloat(bank.amount) + Number.parseFloat(invoiceData.amount)) ;  
                delete bank['.key']
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
            }
            break;
          }
        }
    },
    checkValidity(){
      if(!this.currentPayment.firm) { 
        this.isValidSave =  false;
      } else {
        this.isValidSave = true; 
      }
      if(!this.currentPayment.paymentType) { 
        this.isValidSave = false; 
      }
      else {
        if(this.currentPayment.paymentType == 'Cash') {
          if(!this.currentPayment.amount) {
            this.isValidSave = false;
          } else {
            this.isValidSave = true; 
          }
        } else {
          if(!this.currentPayment.bank) {
            this.isValidSave = false;
          } else {
            if(!this.currentPayment.amount) {
              this.isValidSave = false;
            }
            else {
              this.isValidSave = true; 
            }
          }
        }
      }
    },
    savePayment() {
      let closedDate = new Date(this.currentPayment.date);
      let todayDate = new Date()
      let selectedDate = new Date(closedDate.getFullYear(),closedDate.getMonth(),closedDate.getDate(),todayDate.getHours(),todayDate.getMinutes(),todayDate.getSeconds())
      this.currentPayment.date =  new Date(selectedDate).getTime();
      this.currentPayment['isBuyer'] = this.isBuyer;
      this.currentPayment['buyerId'] = this.currentUser['.key'];
      if(this.currentPayment.paymentType == 'Bank') { 
          this.currentPayment['transferType'] = this.transferType;
          this.currentPayment['transferDetails'] = this.transferDetails;
      }
      this.$root.$firebaseRefs.customerPayments.push(this.currentPayment);
      //this.addRemainingBalance();
      this.successText = this.currentPayment.settledInvoiceDetails.length +" invoice(s) has been updated.";
      this.addDipositDialog = false;
      this.snackbar = true;
      this.getBalance();
      this.isSaving = false;
      this.saveReceiptNumber(this.currentPayment)
    },
    updatePayment() {
      let closedDate = new Date(this.currentPayment.date);
      let todayDate = new Date()
      let selectedDate = new Date(closedDate.getFullYear(),closedDate.getMonth(),closedDate.getDate(),todayDate.getHours(),todayDate.getMinutes(),todayDate.getSeconds())
      this.currentPayment.date =  new Date(selectedDate).getTime();
      let paymentId = this.currentPayment['.key'];
      delete this.currentPayment['.key'];
      this.$root.$firebaseRefs.customerPayments.child(paymentId).update(this.currentPayment, () => {
      })
      //this.addRemainingBalance();
      this.successText = this.currentPayment.settledInvoiceDetails.length +" invoice(s) has been updated.";
      this.addDipositDialog = false;
      this.snackbar = true;
      this.getBalance();
      this.isSaving = false;
    },
    getCurrentUser() {
      if(this.$route.params.customerId !='null') {
        let buyer = this.buyers.filter(item=> item['.key'] == this.$route.params.customerId)[0];
        let seller = this.sellers.filter(item=> item['.key'] == this.$route.params.customerId)[0];
        this.isBuyer = buyer ? true : false;
        this.currentUserId =  this.$route.params.customerId;
      }
    },
    saveReceiptNumber(){
      if(!this.currentPayment.multiFirm) {
        if(this.isBuyer) {
                        this.$root.$firebaseRefs.firm.child(this.currentPayment.firm).update(
          {
            lastReceiptCount: Number.parseInt(this.currentPayment.receiptNumber),
          },
          () => {
            //console.info("last receiptNumber updated...");
          }
        );
        } else {
                        this.$root.$firebaseRefs.firm.child(this.currentPayment.firm).update(
          {
            lastReceiptCountSeller: Number.parseInt(this.currentPayment.receiptNumber),
          },
          () => {
            //console.info("last receiptNumber updated...");
          }
        );
        }

      }
    },
    addDiposit() {

      this.currentPayment = {
        amount: 0,
        buyerId : this.currentUser['.key'],
        brand : this.selectedBrand,
        paymentType: 'Cash',
        firm : this.defaultFirm || null,
        bank : null,
        date : new Date().toISOString().substr(0, 10),
        receiptNumber : 1
      };
      this.setReceiptNumber();
      this.addDipositDialog = true;
    },
    setReceiptNumber(){
        let firm = this.firms.find(item => item['.key'] == this.currentPayment.firm);
        let firmReceiptCount = this.isBuyer ? (firm.lastReceiptCount ? (Number.parseInt(firm.lastReceiptCount) +1) : 1) : (firm.lastReceiptCountSeller ? (Number.parseInt(firm.lastReceiptCountSeller) +1) : 1);
        let firmSettings = this.firmSettings.find(i => i['firm'] == this.currentPayment.firm);
          if (firmSettings && firmSettings.receiptNumberFinReset) {
            let newCount = this.customerPayments.filter(
              (item) =>
                item["brand"] === this.selectedBrand &&
                item["date"] <= new Date().getTime() &&
                item["date"] >= new Date(this.finYear.start).getTime()
            ).length;
            firmReceiptCount = newCount;
          }
        // let firmReceiptCount = Number.parseInt(this.customerPayments.filter(
        // item => (item["brand"] === this.selectedBrand &&
        //     (item["firm"] == this.currentPayment.firm) &&
        //     (item.date >= this.finYear.start) && (item.date <= this.finYear.end))
        // ).length || 1);
        this.currentPayment.receiptNumber = firmReceiptCount;
    },
    editPayment(payment) {
      this.currentPayment =Object.assign({},payment);
      this.currentPayment.date = new Date(this.currentPayment.date).toISOString().substr(0, 10)
      this.addDipositDialog = true;
    },
    deleteFromDialog(){
      this[this.currentPasswordMethod](this.currentPasswordReference);
    },
    deletePayment(payment) {
      let firmSettings = this.firmSettings.find(i => i['firm'] == payment.firm);
      let hasPassword = firmSettings && firmSettings.deleteWithPassword && !!firmSettings.deleteInvoicePassword;
      if(!payment.multiFirm && hasPassword && this.password != firmSettings.deleteInvoicePassword && this.passwordDialog) {
        alert("Incorrect Password");
        this.passwordDialog = false;
        this.password = null;
      } else if (!payment.multiFirm && hasPassword && !this.passwordDialog){
        this.passwordDialog = true;
        this.password = null;
        this.currentPasswordReference = payment;
        this.currentPasswordMethod = "deletePayment";
      } else if (window.confirm("Do you want to Delete ?")) {
        this.passwordDialog = false;
        this.password = null;
        this.currentPayment = Object.assign({},payment);
        this.undoInvoicePayment(this.currentPayment,false)
        this.manageDeletes(this.currentPayment);
        this.$root.$firebaseRefs.customerPayments.child(payment[".key"]).remove();
        //this.addRemainingBalance();
      }
    }, 
    async printPayment(item){
      // console.log(item)
      let termsAndConditions = this.getTermsAndConditions(item);
      if(!item.multiFirm){
        await paymentReceiptPDF({
            firm: Object.assign({},this.firms.filter(item1 => item1['.key'] == item.firm)[0]),
            customer: this.currentUser,
            terms : termsAndConditions[0],
            payment : item
      }).then((doc) => {
          pdfMake.createPdf(doc).download(this.currentUser.name + "_Receipt");
      });
      }
    },
    getTermsAndConditions(invoiceData) {
      let termsAndConditions = this.termsAndConditions.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["firm"] === invoiceData.firm
      );
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.bankById[bankId];
            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      return termsAndConditions;
    },
    getAddress(item) {
      if (!item) {
        return "";
      }
      let address =
        (item.village ? item.village + " - " : "") +
        (item.block ? item.block + " - " : "") +
        (item.tehsil ? item.tehsil + " - " : "") +
        (item.district ? item.district + " - " : "") +
        (item.state ? item.state + " - " : "") +
        (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    // addRemainingBalance(){
    //   let advanceDeposit = this.customerDeposit.filter(
    //     item =>
    //       item["brand"] === this.selectedBrand &&
    //       item["buyerId"] === this.currentUser['.key'] &&
    //       item["type"] === "Advance" &&
    //       !!item["isUserCreated"] && 
    //       (parseInt(item["remainingAmount"]) > 0)
    //   );
    //   let advanceDepositTotal = 0;
    //   advanceDeposit.map((inv,index)  => {
    //     advanceDepositTotal += Number.parseFloat(inv.remainingAmount);
    //   });
    //   let openingBalance = this.customerDeposit.filter(
    //     item =>
    //       item["brand"] === this.selectedBrand &&
    //       item["buyerId"] === this.currentUser['.key'] &&
    //       item["type"] === "Opening Balance" &&
    //        !!item["isUserCreated"] && 
    //       (parseInt(item["remainingAmount"]) > 0)
    //   );
    //   let openingBalanceTotal = 0;
    //   openingBalance.map((inv,index) => {
    //     openingBalanceTotal += Number.parseFloat(inv.remainingAmount);
    //   });
    //   let securityDeposit = this.customerDeposit.filter(
    //     item =>
    //       item["brand"] === this.selectedBrand &&
    //       item["buyerId"] === this.currentUser['.key'] &&
    //       item["type"] === "Security" &&
    //        !!item["isUserCreated"] && 
    //       (parseInt(item["remainingAmount"]) > 0)
    //   );
    //   let securityDepositTotal = 0;
    //   securityDeposit.map((inv,index) => {
    //     securityDepositTotal += Number.parseFloat(inv.remainingAmount);
    //   });
    //   let totalAmount = ((Number.parseFloat(openingBalanceTotal)) - (Number.parseFloat(advanceDepositTotal) + Number.parseFloat(securityDepositTotal)))
    //   if(this.isBuyer) {
    //       this.$root.$firebaseRefs.buyer.child(this.currentUser['.key']).update({
    //         remainingAmountFromDeposite: totalAmount
    //       });
    //   } else {
    //     this.$root.$firebaseRefs.seller.child(this.currentUser['.key']).update({
    //         remainingAmountFromDeposite: totalAmount
    //       });
    //   }
    // },
  }
};
</script>



<style>
.theme--light .customer-switch .v-label {
  color: white !important;
}
.theme--light.v-input--switch__track {
    color: rgba(255, 255, 255, 0.38) !important;
}
.theme--light div.customer-pay-select-firm .v-icon {
  color: white !important;
}
.theme--light div.customer-pay-select-firm .v-label {
  color: white !important;
}
.theme--light div.customer-pay-select-firm .v-input__slot:before {
  border-color: white !important;
  border-image: none !important;
}
div.customer-pay-select-firm .v-select__selection--comma {
  color: white !important;
}

.customer-pay-select-firm  input {
    color: rgb(255 255 255);
}
</style>


// WEBPACK FOOTER //
// src/components/Buyers/CustomerPayments/customerPayments.vue